// Client-side mirror of the server's license check (server is the authority —
// this is purely for UI gating + display).

export type ExpiryKind = 'none' | 'active' | 'warn' | 'expired';

export interface ExpiryStatus {
  kind: ExpiryKind;
  text: string;
  daysLeft: number | null;
  rawDate: string | null;
}

const WARN_DAYS = 30;

function parseUtc(value: string): Date {
  // Server emits "YYYY-MM-DD HH:MM:SS" UTC; normalize for cross-browser parsing.
  return new Date(value.includes('T') ? value : value.replace(' ', 'T') + 'Z');
}

export function expiryStatus(expires_at: string | null | undefined): ExpiryStatus {
  if (!expires_at) {
    return { kind: 'none', text: 'No expiry set', daysLeft: null, rawDate: null };
  }
  const exp = parseUtc(expires_at);
  if (Number.isNaN(exp.getTime())) {
    return { kind: 'none', text: 'No expiry set', daysLeft: null, rawDate: null };
  }
  const ms = exp.getTime() - Date.now();
  const days = Math.ceil(ms / (24 * 60 * 60 * 1000));
  if (days < 0) {
    return { kind: 'expired', text: `Expired ${Math.abs(days)}d ago`, daysLeft: days, rawDate: expires_at };
  }
  if (days <= WARN_DAYS) {
    return { kind: 'warn', text: `Expires in ${days}d`, daysLeft: days, rawDate: expires_at };
  }
  return { kind: 'active', text: `Active until ${expires_at.slice(0, 10)}`, daysLeft: days, rawDate: expires_at };
}
